import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

export const TOOLBAR_POPUP_CLASS_NAME = css.popup

interface Props extends React.PropsWithChildren {
  padding?: number
  extraClassName?: string
  htmlId?: string
}

export const Toolbar: React.FC<Props> = ({
  children,
  extraClassName,
  padding = 4,
  htmlId,
}) => (
  <div
    className={clsJoin(css.container, extraClassName)}
    style={{ padding }}
    id={htmlId}
  >
    {children}
  </div>
)
